export default __webpack_public_path__ + "static/media/python.97a72db0.svg";